module.exports = __webpack_public_path__ + "static/media/27.d7a6076b.avif";